"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.diContainer = exports.CuffLink = void 0;
exports.getKey = getKey;
exports.getLogs = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inversify = require("inversify");
// TODO: Remove these ignores and fix the linter errors from migrating to conform
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-types */

function getKey(keyName, _keyTypetype) {
  return {
    name: keyName
  };
}
var CUFF_LINK_WINDOW_PROP = "$$$cuffLink";
var CUFF_LINK_DI_WINDOW_PROP = "$$$cuffLink_DI";
var CUFF_LINK_LOGS_PROP = "$$$cuffLink_Logs";
/**
 * This will both set up and retrieve a DI container for Cufflink to use.
 * @returns an Inversify container with `Singleton` as the default scope
 */
var getContainer = function getContainer() {
  if (!window[CUFF_LINK_WINDOW_PROP]) {
    var cont = new _inversify.Container({
      defaultScope: "Singleton"
    });
    // Register the actual container on a different window key than the original
    window[CUFF_LINK_DI_WINDOW_PROP] = cont;
    /**
     * Previous versions of Cufflink used a Map to track the registered objects.
     * This object provides a shim to allow backwards compatibility by re-implementing
     * the Map methods that are used in previous versions. We register this shim object
     * in the original window key of Cufflink so when older versions look at this key they
     * get a map-like object like they expect.
     */
    window[CUFF_LINK_WINDOW_PROP] = {
      // Retreive from the DI container as if it were a Map
      get: function get(key) {
        try {
          return CuffLink.fetch({
            name: key
          });
        } catch (e) {
          return undefined;
        }
      },
      // Set something in the DI container as if it were a Map
      set: function set(key, value) {
        CuffLink.register({
          name: key
        }, value);
      }
    };
  }
  return window[CUFF_LINK_DI_WINDOW_PROP];
};

/**
 * Adds a log to the window to be exported to Kibana.
 * NO CUSTOMER INFO ALLOWED HERE
 * @param message String to add to the logs
 */
var addLog = function addLog(message) {
  if (!window[CUFF_LINK_LOGS_PROP]) {
    window[CUFF_LINK_LOGS_PROP] = [];
  }
  window[CUFF_LINK_LOGS_PROP].push({
    message: message
  });
};
var getLogs = function getLogs() {
  var _window$CUFF_LINK_LOG;
  return (_window$CUFF_LINK_LOG = window[CUFF_LINK_LOGS_PROP]) !== null && _window$CUFF_LINK_LOG !== void 0 ? _window$CUFF_LINK_LOG : [];
};
/**
 * @deprecated Use the inversify container exposed as `container`
 */
exports.getLogs = getLogs;
var CuffLink = /*#__PURE__*/function () {
  function CuffLink() {
    (0, _classCallCheck2.default)(this, CuffLink);
  }
  (0, _createClass2.default)(CuffLink, null, [{
    key: "register",
    value:
    /**
     *
     * @deprecated Use `.bind` on the inversify container exposed as `container`
     */
    function register(key, thing) {
      var cont = getContainer();
      /**
       * For migration purposes we want to limit binding to the first binding submitted.
       * This means that things registered in the desktop-shell will take precedence over
       * app-core as they migrate out of app-core into desktop-shell.
       */
      if (cont.isBound(key.name)) {
        var message = "Attempted to bind ".concat(key.name, " to the DI container, but it was already bound");
        addLog(message);
        return;
      }
      cont.bind(key.name).toConstantValue(thing);
    }

    /**
     *
     * @deprecated Use `.get` on the inversify container exposed as `container`
     */
  }, {
    key: "fetch",
    value: function fetch(key) {
      var reg = getContainer();
      if (!reg.isBound(key.name)) {
        throw new Error("Unable to fetch " + key.name);
      }
      return getContainer().get(key.name);
    }
  }]);
  return CuffLink;
}();
/**
 * The default CuffLink Inversify container
 */
exports.CuffLink = CuffLink;
var diContainer = getContainer();
exports.diContainer = diContainer;
//# sourceMappingURL=CuffLink.js.map